class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    console.log('triggeredBy', triggeredBy);
    const allWishlistItems = document.getElementById('wishlist').querySelectorAll('wishlist-product-card');
    const wishlistCountItem = document.getElementById('wishlist-count');
    const emptyWishlistMessage = document.querySelector('.empty-wishlist-message');
    if (allWishlistItems && allWishlistItems != null) {
      wishlistCountItem.innerText = allWishlistItems.length;
    }

    if (allWishlistItems.length == 0) {
      emptyWishlistMessage.classList.remove('hidden');
    } else {
      emptyWishlistMessage.classList.add('hidden');
    }

    const cartItemCountTab = document.getElementById('cart-icon-bubble').innerText.trim().split('(')[1].split(')')[0];
    const count = parseInt(cartItemCountTab, 10);
    const newCount = count;
    if (newCount == 1) {
      let cartDrawer = document.querySelector('cart-drawer');
      console.log('cartDrawer', cartDrawer);
      if (cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
    }
    setTimeout(() => {
      document.getElementById('cart-items-count-tab').innerText = newCount;
    }, 500);

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help

    const completeYourLookContainer = document.querySelector('.complete_your_look-drawer_cart');
    if (completeYourLookContainer) {
      const links = completeYourLookContainer.querySelectorAll('a[data-hide-href]');
      links.forEach((link) => {
        const dataHideHref = link.getAttribute('data-hide-href');
        if (dataHideHref) {
          link.setAttribute('href', dataHideHref);
        }
      });

      const images = completeYourLookContainer.querySelectorAll('img[data-hide-src]');
      images.forEach((image) => {
        const dataHideImage = image.getAttribute('data-hide-src');
        const dataHideSrcSet = image.getAttribute('data-hide-srcset');
        if (dataHideImage) {
          image.setAttribute('src', dataHideImage);
          image.setAttribute('srcset', dataHideSrcSet);
        }
      });
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);

        fetch('/cart', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        })
          .then((response) => response.json())
          .then((data) => {
            const totalPrice = data.total_price / 100;

            const newItemObj = {
              currency: 'EUR',
              value: totalPrice,
              items: [],
            };
            data.items.forEach((item, index) => {
              const percentageDiscount = (item.total_discount / item.price) * 100;

              const finalPercentDiscount = percentageDiscount;
              const newObj = {
                lateral_cart: '1',
                item_id: item.variant_id.toString(),
                item_name: item.title.split(' -')[0],
                currency: 'EUR',
                quantity: item.quantity,
                item_category: item.product_type,
                item_variant: item.variant_id.toString(),
                price: item.price / 100,
                price_new: item.original_line_price / 100,
                item_brand: item.vendor,
                content_group: 'ecommerce',
                sku: item.sku,
                discount: item.total_discount,
                discount_percentage: finalPercentDiscount,
              };

              newItemObj.items.push(newObj);
            });
            if (window.location.pathname != '/cart') {
              setTimeout(() => {
                gtag('event', 'view_cart', newItemObj);
              }, 250);
            }
          });
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
